<template>
  <v-container id="make-right-choice-section" class="text-center mt-10 pa-10">
    <v-row class="why-primerica-us">
      <v-col cols="12" class="mb-3 text-center">
        <h2 class="text-h1">{{ $t('L_you_made_right_choice') }}</h2>
      </v-col>
      <v-col cols="12" sm="4" md="4" class="text-center">
        <v-row justify="center" class="align-start fill-height">
          <v-col class="pt-4 px-4">
            <div justify="center" class="d-flex align-center">
              <v-img
                :src="partneringIcon"
                alt="partnering icon"
                role="presentation"
                aria-hidden="true"
                width="65"
                height="65"
              />
            </div>
            <div role="heading" aria-level="3" class="text-body-2 mt-3 pt-1 font-weight-bold">
              <span>{{ $t('L_partner_with_company') }}</span
              ><br />
              <span>{{ $t('L_you_can_trust') }}</span>
            </div>
            <div
              id="text-body"
              class="text-body-2 mt-3 pt-1"
              v-html="
                $t(
                  isCanadaPolicy
                    ? 'L_largest_distribution_canada'
                    : 'L_named_one_america_fortune_1000'
                )
              "
            ></div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4" md="4" class="text-center">
        <v-row justify="center" class="align-start fill-height">
          <v-col class="pt-4 px-4">
            <div justify="center" class="d-flex align-center">
              <v-img
                :src="protectingIcon"
                alt="protectingIcon"
                role="presentation"
                aria-hidden="true"
                width="65"
                height="65"
              />
            </div>
            <div
              role="heading"
              aria-level="3"
              class="text-body-2 mt-3 pt-1 font-weight-bold"
              v-html="$t('L_protect_loved_one')"
            ></div>
            <div
              id="text-body-info"
              class="text-body-2 mt-3 pt-1"
              v-html="$t(isCanadaPolicy ? 'L_coast_to_coast_canada' : 'L_ninety_four_percent')"
            ></div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4" md="4" class="text-center">
        <v-row justify="center" class="align-start fill-height">
          <v-col class="pt-4 px-4">
            <div class="d-flex justify-center align-center">
              <v-img
                :src="investingIcon"
                alt="investingIcon"
                role="presentation"
                aria-hidden="true"
                width="65"
                height="65"
              />
            </div>
            <div
              role="heading"
              aria-level="3"
              class="text-body-2 mt-3 pt-1 font-weight-bold"
              v-html="$t('L_invest_for_future')"
            ></div>
            <div
              class="text-body-2 mt-3 pt-1"
              v-html="
                $t(
                  isCanadaPolicy ? 'L_pfsl_investments_canada_ltd' : 'L_more_than_2andhalf_million'
                )
              "
            ></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="bottom-disclaimer text-left">
      <v-col cols="12" class="mb-3 text-caption">
        <div
          v-html="
            $t(
              isCanadaPolicy
                ? 'L_Life_insurance_offered_by_Primerica_Life_Canada'
                : 'L_from_fortune_magazine_us1'
            )
          "
        ></div>
        <div
          class="pt-4"
          v-if="!isCanadaPolicy"
          v-html="$t('L_numbers_reflect_the_combined_totals_as_of_us2')"
        ></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import partneringIcon from './assets/partnering-icon.svg';
import protectingIcon from './assets/protecting-icon.svg';
import investingIcon from './assets/investing-icon.svg';

const componentOptions: ComponentOptions = {
  name: 'WhyPrimerica',
  data() {
    return { partneringIcon, protectingIcon, investingIcon };
  },
  props: {
    isCanadaPolicy: {
      type: Boolean,
      default: false,
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
#make-right-choice-section {
  max-width: 1024px;
  color: #fff;
  background: #264568;
}
.bottom-disclaimer {
  margin: 40px -40px -40px -40px;
  color: #fff;
  background: #1a3d5c;
  padding: 40px;
}
</style>
